export default {
  components: [
    {
      data: [
        // {
        //   altText: "Mavcom Logo",
        //   direction: "left",
        //   id: "mavcomlogo",
        //   imageUrl: "https://images.contentstack.io/v3/assets/blt51aa173d8d62b412/blted3dc72cce1b5380/60c9d3b94e87de56c8122c31/mavcomlogo-en.png",
        //   newTab: "TRUE",
        //   redirectUrl: "https://www.mavcom.my/en/consumer/make-a-complaint/",
        //   type: "image",
        // },
        {
          altText: "",
          direction: "",
          id: "",
          imageUrl: "",
          newTab: "",
          redirectUrl: "",
          type: "footer-notes",
        },
        // {
        //   altText: "Airasia - 10 years success",
        //   direction: "right",
        //   id: "awardimage",
        //   imageUrl:
        //     "https://images.contentstack.io/v3/assets/blt51aa173d8d62b412/blta47c75dfb2cf0341/60c9d3b9610188558e3b335d/airasiacom_monogram.png?width=80&height=80&quality=80&format=jpg&auto=webp",
        //   newTab: "TRUE",
        //   redirectUrl: "https://www.airasia.com/",
        //   type: "image",
        // },
      ],
    },
  ],
  content1: [
    {
      data: [
        {
          cnUrl:
            "http://cms.airasia.com/my/en/about-us/terms-and-conditions.page",
          label: "Terms and Conditions",
          newTab: "TRUE",
          url:
            "https://www.airasia.com/my/en/about-us/terms-and-conditions.page",
        },
        {
          cnUrl:
            "http://www.airasia.com/aa/about-us/en/gb/terms-of-use-cn.html",
          label: "Terms of Use",
          newTab: "TRUE",
          url: "https://www.airasia.com/my/en/about-us/terms-of-use.page",
        },
        {
          cnUrl: "http://cms.airasia.com/my/en/about-us/privacy-policy.page",
          label: "Privacy Statement",
          newTab: "TRUE",
          url: "https://www.airasia.com/my/en/about-us/privacy-policy.page",
        },
        {
          cnUrl: "",
          label: "亚航商务服务(广州)有限公司",
          newTab: "TRUE",
          url: "https://www.airasia.com/zh/cn",
        },
        {
          cnUrl: "",
          label: "粤ICP备17160544号-2",
          newTab: "TRUE",
          url: "https://www.beian.miit.gov.cn/",
        },
        {
          cnUrl: "",
          label: "证照信息",
          newTab: "TRUE",
          url:
            "https://a.staticaa.com/pdf/business-license/wofe-business-license.pdf",
        },
      ],
    },
  ],
  content2: [
    {
      data: [
        {
          cnUrl: "",
          label: "AirAsia Berhad (Malaysia)",
          newTab: "TRUE",
          url:
            "https://www.airasia.com/my/en/about-us/ir-organizational-structure.page",
        },
        {
          cnUrl: "",
          label: "Thai AirAsia Co. Ltd",
          newTab: "TRUE",
          url:
            "https://www.aavplc.com/index.html?menu=aav_organisation_chart&lang=en",
        },
        {
          cnUrl: "",
          label: "PT Indonesia AirAsia",
          newTab: "TRUE",
          url:
            "https://www.airasia.com/my/en/about-us/airasia-indonesia-organizational-structure.page",
        },
        {
          cnUrl: "",
          label: "Philippines AirAsia Inc.",
          newTab: "TRUE",
          url:
            "https://www.airasia.com/my/en/about-us/airasia-philippine-organizational-structure.page",
        },
        {
          cnUrl: "",
          label: "AirAsia X Berhad (Malaysia)",
          newTab: "TRUE",
          url: "https://www.airasiax.com/",
        },
        {
          cnUrl: "",
          label: "Thai AirAsia X Co.,Ltd ",
          newTab: "TRUE",
          url:
            "https://www.airasia.com/my/en/about-us/thai-airasia-x-organizational-structure.page",
        },
        {
          cnUrl: "",
          label: "AirAsia Japan Co., Ltd.",
          newTab: "TRUE",
          url:
            "https://www.airasia.com/jp/ja/about-us/airasia-japan-company-profile.page",
        },
        {
          cnUrl: "",
          label: "AirAsia (India) Limited",
          newTab: "TRUE",
          url:
            "https://www.airasia.com/my/en/about-us/airasia-india-organizational-structure.page",
        },
      ],
    },
  ],
  footerNotes: [
    {
      data: [
        {
          content:
            "©2020 AirAsia Group Berhad. Your usage of the AirAsia website indicates that you agree to be bound by our {0}, {1} and {2}.Fares include airport taxes and all applicable fees and charges imposed by the relevant regulatory bodies.This website is owned and operated by AirAsia Berhad (284669-W) (“AirAsia”). {3} {4} {5}",
          id: "content1",
        },
        {
          content: "{0} | {1} | {2} | {3} | {4} | {5} | {6} | {7}",
          id: "content2",
        },
      ],
    },
  ],
}
